<template>
  <ViewContainer :title="$t('organization_settings.ai_settings')">
    <v-sheet elevation="2" class="white rounded d-flex flex-column">
      <v-tabs v-model="activeTab" slider-color="blue" slider-size="4">
        <v-tab active-class="grey--text text--darken-4">{{
          $t('ai_features.usage.usage_tab_title')
        }}</v-tab>

        <v-tab active-class="grey--text text--darken-4">{{
          $t('ai_features.user_access_control.tab_title_user_access')
        }}</v-tab>

        <v-tab active-class="grey--text text--darken-4">{{
          $t('ai_features.token_deposit_history.assignment_history')
        }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <UsageTab ref="usageTab" />
        </v-tab-item>
        <v-tab-item>
          <UserAccessTab @aiTokenLimitUpdated="refreshTokensUsage" />
        </v-tab-item>
        <v-tab-item>
          <DepositHistoryTab />
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </ViewContainer>
</template>

<script>
import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import UsageTab from './UsageTab.vue'
import UserAccessTab from './UserAccessTab.vue'
import DepositHistoryTab from './DepositHistoryTab.vue'

export default {
  name: 'AISettingsView',

  components: {
    ViewContainer,
    UsageTab,
    UserAccessTab,
    DepositHistoryTab,
  },

  data() {
    return {
      activeTab: 0,
    }
  },

  methods: {
    refreshTokensUsage() {
      this.$refs.usageTab.fetchTokensUsage()
    },
  },
}
</script>
